import type { TAgentAccountType } from '../../../../types/userData';

export const getProfileLinkLabel = (agentAccountType?: TAgentAccountType | null): string => {
  switch (agentAccountType) {
    case 'specialist':
      return 'О риелторе';
    case 'agency':
      return 'Об агентстве';
    default:
      return 'Профиль';
  }
};
